import {useState, useEffect} from 'react';
import {useNavigation, useRoute} from '@react-navigation/native';
import {api} from '../../../../../services/api';
import {PedidoDTO} from '../../../../../dtos/PedidoDTO';
import {CouponDTO} from '../../../../../dtos/CouponDTO';
import {Discount, Localidade} from '../modules/types';

type Params = {
  pedidos: PedidoDTO | null;
  localidade: Localidade | null;
  coupon: CouponDTO | null;
  discount: Discount;
};

export interface DiscountState {
  isLoadingCoupon: boolean;
  fetchDiscounts: (code: string) => Promise<void>;
}

export function useDiscount({
  pedidos,
  localidade,
  coupon,
  discount,
}: Params): DiscountState {
  const navigation = useNavigation();
  const route = useRoute();
  const [isLoadingCoupon, setIsLoadingCoupon] = useState(!!coupon);

  async function fetchDiscounts(code: string) {
    if (!pedidos || !localidade) {
      setIsLoadingCoupon(false);
      return;
    }
    setIsLoadingCoupon(true);
    try {
      const {data} = await api.post('/descontos', {
        codigoDesconto: code,
        produtos: [
          {
            id: pedidos.fuelId,
            produto: pedidos.name,
            volume: pedidos.liters,
            quantity: pedidos.quantity,
          },
        ],
        regiao: localidade.region,
      });
      navigation.setParams({
        ...route.params,
        discount: {
          code,
          stations: [],
          value: data,
          membro: discount?.membro,
          placa: discount?.placa,
        },
      });
    } catch (error) {
      console.error('Erro ao processar descontos', error);
    } finally {
      setIsLoadingCoupon(false);
    }
  }

  useEffect(() => {
    if (coupon) {
      fetchDiscounts(coupon.codigo);
    }
  }, [coupon]);

  return {isLoadingCoupon, fetchDiscounts};
}
